import clsx from "clsx";
import { Eye, EyeOff } from "lucide-react";
import { useState } from "react";
import ControlGroup from "../../controlgroup";
import ControlGroupSegment from "../../controlgroup/controlGroupSegment";
import Input from "../../input";
import { PasswordControlProps } from "../types";

const Password = (
  props: Readonly<
    Omit<PasswordControlProps, "type"> & {
      className?: string;
      segmented?: boolean;
    }
  >,
) => {
  const {
    className,
    error,
    segmented,
    value,
    onChange,
    onBlur,
    getInputRef,
    ...rest
  } = props;
  const [showPassword, setShowPassword] = useState(false);

  const input = (
    <Input
      {...rest}
      className={clsx(
        "[&::-ms-reveal]:hidden [&::-ms-clear]:hidden",
        className,
      )}
      error={error}
      type={showPassword ? "text" : "password"}
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
      onBlur={() => {
        onBlur?.();
      }}
      ref={getInputRef}
    />
  );

  const action = (
    <ControlGroup.Button
      type="button"
      variant="light"
      onClick={() => setShowPassword((prev) => !prev)}
      aria-label={showPassword ? "Hide password" : "Show password"}
    >
      {showPassword ? <EyeOff /> : <Eye />}
    </ControlGroup.Button>
  );

  if (segmented)
    return (
      <>
        <ControlGroupSegment grow>{input}</ControlGroupSegment>
        <ControlGroupSegment>{action}</ControlGroupSegment>
      </>
    );

  return (
    <ControlGroup>
      <ControlGroup.Item grow invalid={!!error}>
        {input}
      </ControlGroup.Item>
      <ControlGroup.Item>{action}</ControlGroup.Item>
    </ControlGroup>
  );
};

export default Password;
